import { Button } from './button.js';

let FileInput = {
  ...Button,
  baseStyle: {
    ...Button.baseStyle,
    display: "flex",
    alignItems: "center",
    width: "fit-content",
    "::-webkit-file-upload-button": {
      WebkitAppearance: "button",
      font: "inherit"
    }
  }
};

export { FileInput };
